import { Tabs } from 'antd';
import { useMemo, useState } from 'react';

import { DocumentReceiptEntity } from '../../../../generated-api';
import { FormComponentProps } from '../../defs/types';
import { ReceiptFormInputs } from '../ReceiptFormInputs';
import { DocumentDualReceiptEntity } from './types';

const { TabPane } = Tabs;

export function DualReceiptFormComponent({
  changed,
  documentId,
  entity,
  groupId,
  setChanged,
}: FormComponentProps<DocumentDualReceiptEntity>) {
  const [tab, setTab] = useState('0');
  const formEntities: DocumentReceiptEntity[] = useMemo(
    () =>
      entity.receipts.map((receipt) => ({
        type: receipt.type,
        payment_date: receipt.payment_date,
        payee: receipt.payee,
        business_number: receipt.business_number,
        receipt_details: receipt.receipt_details,
      })),
    [entity.receipts]
  );

  return (
    <>
      <Tabs defaultActiveKey={tab} onChange={setTab}>
        {formEntities.map((form, index) => (
          <TabPane key={index} forceRender tab={`領収書${index + 1}`} tabKey={index.toString()}>
            <ReceiptFormInputs
              changed={changed}
              documentId={documentId}
              entity={form}
              groupId={groupId}
              path={['resultReceipts', index]}
              setChanged={setChanged}
            />
          </TabPane>
        ))}
      </Tabs>
    </>
  );
}
